import { Col, Row } from 'antd';
import { memo } from 'react';
import HistoryNavigation from './HistoryNavigation';
import Header from './Header';
import { Search } from './Search';
import useIsMobile from '../../../../utils/isMobile';

export const Navbar = memo(() => {
  const isMobile = useIsMobile();

  return (
    <Row
      align='middle'
      wrap={false}
      className='navbar'
      style={{ margin: 0, width: '100%', display: 'flex' }}
    >
      <Col flex={1} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <HistoryNavigation />
      </Col>

      {!isMobile && (
        <Col flex="0 0 auto" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Search />
        </Col>
      )}

      <Col flex={1} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Header opacity={1} />
      </Col>
    </Row>
  );
});
